import React, { Component } from 'react';
import cx from 'classnames';
import { withRouter } from 'react-router-dom';
import { Convert } from 'src/helpers';
import { IMAGES } from 'src/constants';
import { ThemeModal } from 'src/components';
import styles from './_desktopOneTimeTransactionsSuccess.module.scss';

class DesktopOneTimeTransactionsSuccess extends Component {
  render() {
    const { checkoutDetail, status, reason, history } = this.props;
    const isSuccess = status === 'success';

    return (
      <div className={styles['sip']}>
        <ThemeModal
          show
          title={checkoutDetail?.oneClickCheckout?.fundName}
          logo={checkoutDetail?.oneClickCheckout?.partner?.logo || IMAGES.MOTILAL_OSWAL}
          isBack
        >
          <div className={styles['mobile-sip-transactions']}>
            <div>
              <div className={styles['main-title']}>
                {isSuccess ? (
                  <>
                    You have successfully invested in <br />
                    {Convert.toCapitalizeLetters(
                      checkoutDetail?.oneClickCheckout?.partner?.name ||
                        checkoutDetail?.oneClickCheckout?.amcName,
                    )}
                  </>
                ) : (
                  <>Payment failed</>
                )}
              </div>

              <div
                className={cx(styles['green-check'], {
                  [styles['failed-check']]: !isSuccess,
                })}
              >
                {isSuccess ? (
                  <img src="/img/okay-icon.svg" alt="ok" />
                ) : (
                  <img src="/images/failed.png" alt="failed" />
                )}
              </div>

              {isSuccess ? (
                <>
                  <div className={styles['monthly-title']}>
                    Transaction ID:{' '}
                    <span>{checkoutDetail?.oneClickCheckout?.depositRequestId}</span>
                  </div>
                </>
              ) : (
                <div className={styles['monthly-title']}>{reason}</div>
              )}
            </div>
            <div className={styles['footer-spacer']} />

            {!isSuccess && (
              <div
                className={cx(styles['footer'], {
                  [styles['disabled-footer']]: false,
                })}
              >
                <button onClick={() => history.goBack()} disabled={false}>
                  RETRY
                </button>
              </div>
            )}
            <div className={styles['powered-by']}>powered by savvy</div>
          </div>
        </ThemeModal>
      </div>
    );
  }
}

export default withRouter(DesktopOneTimeTransactionsSuccess);
